import React, { useEffect, useState } from "react";
import {
  Breadcrumbs,
  Link,
  Drawer,
  Divider,
  Typography
} from "@material-ui/core";
import { HomeOutlined } from "@material-ui/icons";
import BacktoHomeBtn from "../components/commons/BacktoHomeBtn";
import useStyles from "../styles/accessManagementStyle.js";
import { useTranslation } from "../langs/useTranslation";
import RoleManagementTable from "../components/accessManagement/RoleManagementTable";
// import PermissionManagementTable from "../components/accessManagement/PermissionManagementTable";
import CompanySelector from "../components/accessManagement/CompanySelector.js";
import localforage from "localforage";

const AccessManagement = () => {
  const classes = useStyles();
  const { t } = useTranslation("accessManagement");
  const [selectedCompanyId, setSelectedCompanyId] = useState();

  const handleCompanySelect = companyId => {
    setSelectedCompanyId(companyId[0]);
  };

  useEffect(() => {
    const lastCompanyId = sessionStorage.getItem("lastCompanyId");
    if (lastCompanyId) {
      setSelectedCompanyId(lastCompanyId);
      sessionStorage.removeItem("lastCompanyId");
      return;
    }
    localforage.getItem("userCompanyID").then(setSelectedCompanyId);
  }, []);

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <BacktoHomeBtn />
      {/* <Divider /> */}
    </div>
  );

  return (
    <div className={classes.root}>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Drawer
          classes={{
            paper: classes.drawerPaper
          }}
          variant="permanent"
          open
        >
          {drawer}
        </Drawer>
      </nav>
      <main className={classes.content}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/">
            <HomeOutlined />
            {t({ defaultMessage: "首页" })}
          </Link>
          <Typography color="textPrimary">
            {t("accessManagement.title")}
          </Typography>
        </Breadcrumbs>
        <div className={classes.titleSection}>
          <Typography variant="h4">{t("accessManagement.title")}</Typography>
          <Typography variant="body1">
            {t("accessManagement.description")}
          </Typography>
        </div>
        <CompanySelector
          companyId={selectedCompanyId}
          onSelect={handleCompanySelect}
        />
        <div className={classes.tableSection}>
          <Typography variant="h6">
            {t("accessManagement.roleManagement")}
          </Typography>
          {selectedCompanyId && (
            <RoleManagementTable companyId={selectedCompanyId} />
          )}
        </div>
        {/* <div className={classes.tableSection}>
          <Typography variant="h6">
            {t("accessManagement.permissionManagement")}
          </Typography>
          <PermissionManagementTable />
        </div> */}
      </main>
    </div>
  );
};

export default AccessManagement;
